/* eslint-disable */
const getters = {
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
